import _ from "lodash";
import React, { useState, useEffect, useMemo } from "react";
import "./index.scss";

type CheckboxProps = {
  onChange: (checked: boolean) => void;
  checked?: boolean;
  label: string;
  type: "radio" | "checkbox";
};

const Checkbox = ({
  onChange,
  checked = false,
  label,
  type = "checkbox",
}: CheckboxProps) => {
  const [isChecked, setChecked] = useState(checked);
  useEffect(() => {
    setChecked(checked);
  }, [checked]);
  const uniqueId = useMemo(() => {
    return _.uniqueId('checkbox-');
  }, []);

  return (
    <label htmlFor={uniqueId} className="checkbox">
      <input
        type={type}
        onChange={(e) => {
          setChecked(e.target.checked);
          onChange(e.target.checked);
        }}
        checked={isChecked}
        id={uniqueId}
      />
      <span className="label">{label}</span>
    </label>
  );
};

export default Checkbox;
